import type { DocumentsListRow } from "@/admin/entities/documents";
import type { DocumentsListQueryQueryType } from "@/types/graphql/admin.generated";

/**
 * Мапперы для feature управления документами
 * Используют конкретные типы из GraphQL кодгена
 */

// Трансформация данных GraphQL ответа в формат для таблицы
// CRUD компонент ожидает (data: unknown) => TableData<Row>
export function getTableData(data: unknown): {
  nodes: DocumentsListRow[];
  count: number;
} {
  const documents = (data as DocumentsListQueryQueryType)?.documents;

  if (!documents || !documents.nodes) {
    return { nodes: [], count: 0 };
  }

  return documents;
}

// Маппинг данных документа в формат для отображения в таблице
export function mapColumns(document: DocumentsListRow) {
  return [
    document.id,
    document,
    document.slug,
    document.type,
    document.platform,
    document.language,
    document.isPublished,
    document.createdAt,
  ];
}
